import React, { useState, useEffect } from 'react'
import { Row, Col, ButtonGroup, IconButton, Icon, Table, Uploader, Message } from 'rsuite'
import { isRequiredFiled, isValidFileType } from '../../utils/ValidatorUtils'
import { cloneDeep, isEmpty } from 'lodash-es'
import notification from '../../utils/notification'
import EditDateCustomCell from '../../components/cell/EditDateCustomCell'
import moment from 'moment'
import { budgetFormat } from '../../utils/formatterUtil'
import EditNumberCell from '../../components/cell/EditNumberCell'
import InputNumberForm from '../../components/forms/input/InputNumberForm'
import EditTextCell from '../../components/cell/EditTextCell'
import { DD_MM_YYYY_SLASH } from '../../constants/date'
import EditSelectCell from '../../components/cell/EditSelectCell'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import EditMultiCascaderCell from '../../components/cell/EditMultiCascaderCell'

export default function ContractChangeExtendPeriodBudget({
  schema,
  data,
  changeType,
  isEnableBudget,
  isEnablePeriod,
  isView,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  projectEndDate,
  isErrorRequire,
  onChange = () => {},
  setPeriodBudgetChange = () => {},
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table
  const valKey = 'periodBudget'

  const [datas, setDatas] = useState([])

  // useEffect(() => {
  //   register(valKey, schema.change || [])
  //   setValue(valKey, schema.change || [])
  //   setDatas(schema.change || [])
  // }, [schema])

  useEffect(() => {
    //console.log('ContractChangeExtendPeriodBudget data : ', data)

    register(valKey, data || [])
    setValue(valKey, data || [])
    setDatas(data || [])
  }, [data])

  // const [tableData, setTableData] = useState([])

  const onChangeCellValue = (index, value, key) => {
    console.log('index=>', index, ', key=>', key, ', value=>', value)
    let dataList = cloneDeep(datas)

    if (key == schema.newEndDate.name) {
      dataList[index][key] = value ? moment(value).format(DD_MM_YYYY_SLASH) : ''
      //console.log('sss', moment(value).add(1, 'days').format(DD_MM_YYYY_SLASH))
      if (index < dataList.length - 1) {
        dataList[index + 1]['newStartDate'] = moment(value).add(1, 'days').format(DD_MM_YYYY_SLASH)
      }
    } else {
      dataList[index][key] = value
    }

    dataList[index]['isChange'] = true

    setValue(valKey, dataList)

    setDatas(dataList)

    setPeriodBudgetChange(dataList)
  }

  const onAddPeriod = () => {
    let dataList = cloneDeep(datas)

    let lastP = dataList[dataList.length - 1]

    let startDate = moment(lastP.newEndDate, DD_MM_YYYY_SLASH).add(1, 'days')

    dataList.push({
      id: 'NEW',
      period: lastP.period + 1,
      newStartDate: startDate.format(DD_MM_YYYY_SLASH),
      newEndDate: moment(projectEndDate).format(DD_MM_YYYY_SLASH),
      newAmount: 0,
      reasonType: null,
      reasonTypeName: null,
      otherReason: null,
      enableChange: true,
      enableDelete: startDate.isAfter(moment()),
      isChange: true,
    })

    // console.log('dataList : ', dataList)
    setValue(valKey, dataList)

    setDatas(dataList)
    setPeriodBudgetChange(dataList)
  }

  const onDeletePeriod = (index) => {
    let dataList = cloneDeep(datas)

    dataList.splice(index, 1)

    //console.log('dataList : ', dataList)
    setValue(valKey, dataList)

    setDatas(dataList)
    setPeriodBudgetChange(dataList)
  }

  return (
    <>
      <Row style={{ marginTop: 10 }}>
        {datas && (
          <Col xs={24} sm={24} md={24} lg={24}>
            <Table
              height={400}
              autoHeight={datas?.length <= 5}
              wordWrap
              bordered
              data={datas}
              style={{ marginBottom: 10 }}
            >
              <Column width={95} align="center">
                <HeaderCell>งวดที่</HeaderCell>
                <Cell dataKey={'period'} />
              </Column>
              <Column width={150}>
                <HeaderCell>วันที่เริ่มต้น</HeaderCell>
                <Cell dataKey={'newStartDate'} />
              </Column>
              <Column width={isEnablePeriod && !isView ? 170 : 150}>
                <HeaderCell>วันที่สิ้นสุด</HeaderCell>
                <Cell>
                  {(rowData, index) => {
                    if (!isView && isEnablePeriod /*&& rowData.enableChange*/) {
                      return (
                        <EditDateCustomCell
                          id={`${schema.newEndDate.name}_${rowData.period}`}
                          rowData={{
                            ...rowData,
                            startDate: rowData.newEndDate
                              ? moment(rowData.newEndDate).format('DD/MM/YYYY')
                              : moment().startOf('day').toDate(),
                          }}
                          dataKey={schema.newEndDate.name}
                          //isEdit={rowData.enableChange}
                          isEdit={true}
                          register={register}
                          control={control}
                          errors={errors}
                          onChangeCell={(value) => {
                            onChangeCellValue(index, value, schema.newEndDate.name)
                          }}
                          startDate={moment(rowData.newStartDate, 'DD/MM/YYYY').add(1, 'days')}
                          //endDate={projectEndDate}
                          endDate={
                            index == datas.length - 1
                              ? moment(projectEndDate)
                              : datas[index + 1]?.newEndDate
                                ? moment(datas[index + 1]?.newEndDate, 'DD/MM/YYYY').add(-2, 'days')
                                : moment(projectEndDate)
                          }
                        />
                      )
                    } else {
                      return <span>{rowData.newEndDate}</span>
                    }
                  }}
                </Cell>
              </Column>
              {isEnableBudget && (
                <Column width={180} align="right">
                  <HeaderCell>จำนวนเงินงวด</HeaderCell>
                  <Cell>
                    {(rowData, index) => {
                      if (!isView && isEnableBudget && rowData.enableChange) {
                        //console.log('rowData.enableChange : ', rowData.enableChange)

                        return (
                          <div style={{ marginTop: 10 }}>
                            <EditNumberCell
                              isBudgetFormat
                              id={`${schema.newAmount.name}_${rowData.period}`}
                              rowData={{
                                ...rowData,
                                newAmount: rowData.newAmount,
                              }}
                              dataKey={schema.newAmount.name}
                              isEdit={rowData.enableChange}
                              register={register}
                              control={control}
                              errors={errors}
                              onChangeCell={(value) => {
                                onChangeCellValue(index, value, schema.newAmount.name)
                              }}
                              styleSheet={{ textAlign: 'right', width: '98%', marginTop: 8 }}
                            />
                          </div>
                        )
                      } else {
                        return <span>{budgetFormat(rowData.newAmount)}</span>
                      }
                    }}
                  </Cell>
                </Column>
              )}
              <Column width={250} minWidth={250} flexGrow={1}>
                <HeaderCell>เหตุผล</HeaderCell>
                <Cell>
                  {(rowData, index) => {
                    if (isEnablePeriod || isEnableBudget) {
                      // console.log('schema.reason : ', schema)

                      var val = rowData[schema.reasonType.name]?.length ?? 0

                      var isError = isErrorRequire && val < 1

                      var isChange = rowData.enableChange || rowData.isChange

                      return (
                        <>
                          {!isView && isChange ? (
                            <>
                              <EditMultiCascaderCell
                                id={`${schema.reasonType.name}_${rowData.period}`}
                                rowData={rowData}
                                //rowSchema={schema.reasonType}
                                dataKey={schema.reasonType.name}
                                items={schema.reasonType?.options || []}
                                //items={[]}
                                // disabledItemValues={[
                                //   watchMasterBudgetPlanValue?.[rowData.numInstallment - 1],
                                // ]}
                                placeholder={'ระบุ' + schema.reasonType.label}
                                uncheckableItemValues={schema.reasonType.unSelected || []}
                                isEdit={isChange}
                                error={isError}
                                register={register}
                                control={control}
                                errors={errors}
                                menuHeight={350}
                                menuWidth={300}
                                onChangeCell={(value) => {
                                  onChangeCellValue(index, value, schema.reasonType.name)
                                }}
                              />
                            </>
                          ) : (
                            <>{rowData.reasonTypeName}</>
                          )}
                        </>
                      )
                    } else {
                      return rowData.reasonTypeName
                    }
                  }}
                </Cell>
              </Column>
              <Column width={250} minWidth={250} flexGrow={1}>
                <HeaderCell>กรณีอื่นๆ</HeaderCell>
                <Cell>
                  {(rowData, index) => {
                    var a = rowData.reasonType?.find((e) => e.endsWith('99'))
                    var isHaveOther = a != null

                    if (isEnablePeriod || isEnableBudget) {
                      // console.log('schema.reason : ', schema)

                      return (
                        <>
                          {!isView && isHaveOther && (
                            <EditTextCell
                              id={`${schema.otherReason.name}_${rowData.period}`}
                              rowData={rowData}
                              rowSchema={schema.otherReason}
                              dataKey={schema.otherReason.name}
                              isEdit={rowData.enableChange}
                              register={register}
                              control={control}
                              errors={errors}
                              styleSheet={{ width: '98%', marginTop: 8 }}
                              onChangeCell={(value) => {
                                onChangeCellValue(index, value, schema.otherReason.name)
                              }}
                            />
                          )}
                        </>
                      )
                    } else if (isHaveOther) {
                      return rowData.otherReason
                    } else {
                      return ''
                    }
                  }}
                </Cell>
              </Column>
              {!isView &&
                isEnablePeriod &&
                isEnableBudget &&
                datas?.find((e) => e.enableDelete) && (
                  <Column width={120} align="center">
                    <HeaderCell></HeaderCell>
                    <Cell>
                      {(rowData, index) => {
                        return (
                          <>
                            {rowData.enableDelete &&
                              rowData.enableChange &&
                              index == datas.length - 1 && (
                                <CancelButton
                                  icon="trash"
                                  children="ลบงวด"
                                  onClick={() => {
                                    onDeletePeriod(index)
                                  }}
                                />
                              )}
                          </>
                        )
                      }}
                    </Cell>
                  </Column>
                )}
            </Table>
            {!isView &&
              isEnablePeriod &&
              isEnableBudget &&
              datas[datas.length - 1]?.newEndDate &&
              moment(datas[datas.length - 1]?.newEndDate, DD_MM_YYYY_SLASH) <
                moment(projectEndDate) && (
                <SaveButton icon="plus" children="เพิ่มงวด" onClick={onAddPeriod} />
              )}
          </Col>
        )}
      </Row>
    </>
  )
}
